module.exports = __webpack_public_path__ + "static/media/unSelectedleftnew.ffc8d2c3.svg";